import { schema } from 'normalizr'
import { WIDGETS } from './stateExtension'

const componentSchema = new schema.Entity(
  'components',
  {},
  {
    processStrategy: (entity, parent) => {
      entity.id = `${parent.name}-${entity.name}`
      return entity
    }
  }
)

const widgetSchema = new schema.Entity(
  'widgets',
  {
    components: [componentSchema]
  },
  {
    idAttribute: entity => {
      return entity.name
    },
    mergeStrategy: entity => {
      // adds the widget code as suffix for JOLLY widgets to avoid ambiiguity
      // (even if the name property is reassigned, only the id changes)
      if (entity.name === 'JOLLY') {
        return `${entity.name}_${entity.code}`
      } else {
        return entity.name
      }
    },
    processStrategy: entity => {
      // merges the widget properties from the stateExtension
      if (WIDGETS[entity.name]) {
        for (const key in WIDGETS[entity.name]) {
          if(key==='status' && entity.name==='TITOLARE_EFFETTIVO' && !!entity[key] && entity[key][0]==='ignoreValidation')
          entity[key]=entity[key]
          else if (key !== 'components') entity[key] = WIDGETS[entity.name][key]
          
        }
      }

      return entity
    }
  }
)

export const widgetListSchema = [widgetSchema]



// WEBPACK FOOTER //
// ./state/schema.js